<template>
    <div class="container">
        <h3>药品基本信息</h3>
        <el-form :label-position="labelPosition" label-width="100px">
            <el-form-item label="药品名称:">
                <el-input placeholder="请输入药品名称" v-model="value"></el-input>
            </el-form-item>
            <el-form-item label="入药部分:">
                <el-input placeholder="请输入入药部分" v-model="medicineInpart"></el-input>
            </el-form-item>
            <el-form-item label="单位:">
                <el-input placeholder="请输入单位" v-model="unit"></el-input>
            </el-form-item>
            <el-form-item label="零售价:">
                <el-input placeholder="请输入零售价" v-model="retailPrice"></el-input>
            </el-form-item>
            <el-form-item label="成本价:">
                <el-input placeholder="请输入成本价" v-model="costPrice"></el-input>
            </el-form-item>
            <el-form-item label="药品库存数量:">
                <el-input placeholder="请输入药品库存数量" v-model="number"></el-input>
            </el-form-item>
            <el-form-item label="产地:">
                <el-input placeholder="请输入产地" v-model="manufacturer"></el-input>
            </el-form-item>
            <el-form-item label="药品状态:">
                <template>
                    <el-radio-group v-model="radio" @change='choice'>
                        <el-radio :label="0">启用</el-radio>
                        <el-radio :label="-1">停用</el-radio>
                    </el-radio-group>
                </template>
            </el-form-item>
        </el-form>

        <h4 style="height:35px;line-height: 35px">预警</h4>
        <el-form :label-position="labelPosition" label-width="100px">
            <el-form-item label="库存预警:">
                <el-input v-model="inventoryWarning" placeholder="请输入库存预警"></el-input>
            </el-form-item>
        </el-form>
        <div class="operation">
            <el-button icon="el-icon-download" type="primary" @click="preservation" class="preserve">新增</el-button>
            <el-button icon="el-icon-back" :plain="true" type="info" @click="cancel">返回</el-button>
        </div>
    </div>
</template>
<script>
  export default {
    name: "newdrugs",
    data() {
      return {
        radio: 0,
        labelPosition: 'left',
        costPrice: '',
        inventoryWarning: '',
        manufacturer: "",
        medicineInpart: "",
        number: '',
        retailPrice: '',
        status: 0,
        unit: "",
        value: ""
      };
    },
    methods: {
      preservation() {            //  新增
        let that = this;
        if (that.costPrice != '' && that.retailPrice != '' && that.inventoryWarning != '' && that.manufacturer != '' && that.medicineInpart != '' && that.number != '' && that.unit != '' && that.value != '') {
          that.$axios({
            url: "/api/medicines/addone",
            method: "POST",
            data: {
              costPrice: that.costPrice,
              inventoryWarning: that.inventoryWarning,
              manufacturer: that.manufacturer,
              medicineInpart: that.medicineInpart,
              number: that.number,
              retailPrice: that.retailPrice,
              status: that.radio,
              unit: that.unit,
              value: that.value
            }
          }).then(res => {
            if (res.data.code == 200) {
              this.$router.push({
                path: './nowStock'
              });
            } else {
              that.$notify({
                title: '警告',
                message: '新增失败',
                type: 'warning'
              });
            }
          }).catch(err => {
            console.log(err);
          });
        } else {
          that.$notify({
            title: '警告',
            message: '请将信息填写完整',
            type: 'warning'
          });
        }
      },
      cancel() {                   //  返回
        this.$router.push({path: "./nowStock"});
      },
      choice() {                   //  选择
      }
    }
  };
</script>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .container {
        padding: 25px;
    }

    .container h3 {
        font-weight: normal;
        font-size: 16px;
        color:#95b2d4;
        padding: 10px 0px;
        /*background: #dfe6ec;*/
        margin-bottom: 15px;
    }

    .container h4 {
        font-weight: normal;
        font-size: 16px;
        color: red;
        padding: 10px 0px;
        /*background: #dfe6ec;*/
        margin-top: 20px;
        margin-bottom: 15px;
    }

    .drugs {
        width: 100%;
        height: auto;
    }

    .operation {
        margin-top: 30px;
        float: right;
    }

    .preserve {
        margin-right: 30px;
    }
</style>



// WEBPACK FOOTER //
// newdrugs.vue?5cfb26a6